import { Card, Button, Input } from "../primitives";
import { useAuth } from "../../contexts/AuthContext";
import { useState, useRef, useEffect } from "react";
import Modal from "../portals/Modal";
import Reauthenticate from "../popup/Reauthenticate";
import VerifyNewEmail from "../popup/VerifyNewEmail";
import { catchError } from "../../ErrorUtility";
import useTimedError from "../../hooks/useTimedError";
import { useTranslation } from '../../hooks/useTranslation';

export default function YourAccount({ isReauthed, setIsReauthed }) {
    const { currentUser, updateCurrentUserDisplayName, sendReverificationCode } = useAuth();
    const [error, setError] = useTimedError();
    const [loading, setLoading] = useState(false);
    const [allowSubmit, setAllowSubmit] = useState(false);
    const emailRef = useRef("");
    const nameRef = useRef("");
    const [isOpen, setIsOpen] = useState(false);
    const t = useTranslation();

    async function handleSubmit(e) {
        e.preventDefault();
        if (nameRef.current.value && nameRef.current.value !== currentUser.displayName) {
            setLoading(true);
            const [result, error] = await catchError(updateCurrentUserDisplayName, nameRef.current.value);
            if (error) {
                setError(error.message);
            }
            else {
                nameRef.current.value = "";
            }
            setLoading(false);
        }

        if (emailRef.current.value && emailRef.current.value !== currentUser.email) {
            sendReverificationCode(emailRef.current.value);
            setIsOpen(true);
        }
    }

    function handleChange() {
        // Check if either input has a value that's different from the current user data
        const nameChanged = nameRef.current.value && nameRef.current.value !== currentUser?.displayName;
        const emailChanged = emailRef.current.value && emailRef.current.value !== currentUser?.email;
        
        // Allow submit only if at least one field has changed
        setAllowSubmit(nameChanged || emailChanged);
    }

    return (
        <div>
            <Card ctype="margin-bottom">
                <Card.Header>
                    <h2>{t('Your Account')}</h2>
                </Card.Header>
                <Card.Body>
                    <form onSubmit={handleSubmit}>
                        <Input type="text" ref={nameRef} labelText={t('Name')} placeholder={currentUser?.displayName} onChange={handleChange}/>
                        <Input type="email" ref={emailRef} labelText={t('Email')} placeholder={currentUser?.email} onChange={handleChange}/>
                        <Button className="settings" disabled={!allowSubmit} loading={loading} error={error}>{t('Save Changes')}</Button>
                    </form>
                </Card.Body>
            </Card>
            <Modal open={isOpen} onClickOutside={() => setIsOpen(false)} lock={isReauthed}>
                {isReauthed ? 
                    <VerifyNewEmail 
                        setIsOpen={setIsOpen}
                        error={error}
                        setError={setError}
                        email={emailRef?.current?.value}
                        loading={loading}
                        setLoading={setLoading}
                    /> : 
                    <Reauthenticate setIsReauthed={setIsReauthed} setIsOpen={setIsOpen} error={error} setError={setError}/>
                }
            </Modal>
        </div>
    )
}
